import template from './validation-message.tpl.pug';

class ValidationMessageController {
    get invalid() {
        let keys = String.prototype.split.call(this.key || '', / *, */);
        return keys.some((key) => !!this.$ctrl.$error[key]);
    }
}

export default {
    selector: 'dbAValidationMessage',
    template: template(),
    controller: ValidationMessageController,
    transclude: true,
    require: {
        $ctrl: '^form'
    },
    bindings: {
        key: '@'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/validation-message/validation-message.cmpt.js